import { useEffect } from 'react';

/**
 * Custom event payload — `useScopeSetter` (переключатель «Хозяйство ▾» в
 * сайдбаре, `FarmSwitcher`) фаерит после успешного POST /scope/set. Все
 * виджеты, зависящие от scope (summary, rotation, map markers и т.п.),
 * слушают и перефетчат данные без full reload.
 */
export const SCOPE_CHANGED_EVENT = 'ikolhoz:scope-changed';

export interface ScopeChangedDetail {
  // Sprint 2026-23 T-A6: расширено до canonical 8 scope-types (mirror
  // mapState.ts ScopeType union). Listeners (CulturePalette, summary
  // widgets и т.п.) обрабатывают любой тип через invalidate by key.
  scope_type:
    | 'tenant'
    | 'holding'
    | 'company'
    | 'cluster'
    | 'farm'
    | 'brigade'
    | 'array'
    | 'field';
  scope_id: string | null;
}

export function dispatchScopeChanged(detail: ScopeChangedDetail) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent<ScopeChangedDetail>(SCOPE_CHANGED_EVENT, { detail }),
  );
}

/** Хук: вызывать callback при каждом переключении scope. */
export function useScopeChanged(onChange: (detail: ScopeChangedDetail) => void) {
  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<ScopeChangedDetail>;
      onChange(ce.detail);
    };
    window.addEventListener(SCOPE_CHANGED_EVENT, handler);
    return () => window.removeEventListener(SCOPE_CHANGED_EVENT, handler);
    // onChange intentionally not in deps — иначе каждый re-render пересоздаёт listener.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
